// src/components/GlobalLoader.jsx
import React from "react";
import { useLoader } from "../context/LoaderContext";
import "./GlobalLoader.css";

export default function GlobalLoader() {
  const { loading } = useLoader();
  if (!loading) return null;

  return (
    <div className="global-loader-overlay" role="status" aria-live="polite">
      <div className="global-loader-box">
        <div className="global-spinner" />
        <p className="global-loader-text">Please wait, Loading...</p>
      </div>
    </div>
  );
}
